import styled from 'styled-components';
import { makeStyles, createTheme } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';

export const Button = styled.button`
  width: 150px;
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 50px;
  letter-spacing: 1px;
  margin: 0 ;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
}
`;
export const theme = createTheme({
  palette: {
    primary: orange,
  },
});

const styles = {
  inputs: {
    margin: '10px 0',
  },
  cardAction: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    justifyContent: 'center',
  },

};
export const useStyles = makeStyles(styles);
